module.exports = __webpack_public_path__ + "au.no1.a706cb96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/au.no1.jpg
// module id = /hWM
// module chunks = 0